import React from 'react'
// import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { 
  MainTitle, Subtitle,
  TextContent, HighlightText,
  JsonCodeStyle, LinkText,
} from '../../../Shared';

import { StyledTableCell, StyledTableRow, useTableStyles } from '../../styles/Table.styled';
import { StyledSeparated } from '../FindNearSegments/FindNearSegments.styled';

function createData(fields, type, description) {
  return { fields, type, description };
}

const listBody = [
  createData('token','string',"token of user's device, "),
  createData('lat','number','latitude of position'),
  createData('lng','number','longitude of position'),
  createData('active','boolean','active for notice or not'),
  createData('path_id','string','Id of path get from direct api'),
]

const Notification = props => {
  const classes = useTableStyles();

  const responseSuccess = {
    "code": 200,
    "message": "success",
    "data": {
        "path": null,
        "segment": 6689,
        "_id": "5f1d8ec84fd28f04dde0b765",
        "token": "xxxx",
        "user": "5dc3e711a6da9a3b2cebc1bb",
        "__v": 0,
        "active": true,
        "createdAt": "2020-07-26T14:10:16.470Z",
        "lat": 10.7707105,
        "lng": 106.656221,
        "period": "5f8bd7702ce1ca5de1dd667e",
        "updatedAt": "2020-10-18T05:50:14.656Z"
    }
  }

  return (
    <div>
      <MainTitle>Notification</MainTitle>
      <TextContent>Update position to notice traffic status to users</TextContent>
      <Subtitle id="request-notification">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/notification/update-current-location</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@POST</TextContent>
      <TextContent><b><i>Body:</i></b></TextContent>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Description</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listBody.map((row) => (
              <StyledTableRow key={row.fields}>
                <StyledTableCell>
                  {row.fields}
                </StyledTableCell>
                <StyledTableCell align="left">{
                  row.type
                }</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{
                  row.fields === 'token' ? (
                    <>
                      {row.description} <LinkText target="_blank" path="https://firebase.google.com/docs/cloud-messaging/android/client">Read more</LinkText>
                    </>
                  ) : row.description
                }</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Subtitle id="response-notification">Response</Subtitle>
      <Subtitle isSmall id="success-direct">Success</Subtitle>
      <JsonCodeStyle data={responseSuccess} />

      <StyledSeparated />
    </div>
  )
}

Notification.propTypes = {

}

export default Notification
